import TrialCalcSpecList from '../../components/trialCalcSpecList/TrialCalcSpecList';

const trialCalcSpecList = () => {
  return <TrialCalcSpecList />;
};

export default trialCalcSpecList;
